import { gql } from "@apollo/client";

// Shared by CREATE_GROUP/UPDATE_GROUP so their return shape has one definition.
const GROUP_AUDIT_FIELDS = gql`
  fragment GroupAuditFields on Group {
    uid
    createdBy
    organizationUid
    name
  }
`;

const UPDATE_GROUP = gql`mutation UpdateGroup($name: String!, $uid: UUID!) {
    updateGroupByUid(input: { groupPatch: { name: $name }, uid: $uid }) {
      group {
        ...GroupAuditFields
      }
    }
  }
  ${GROUP_AUDIT_FIELDS}`;

const CREATE_GROUP = gql`mutation CreateGroup($name: String!) {
  createGroup(input: { group: { name: $name } }) {
    group {
      ...GroupAuditFields
    }
  }
}
${GROUP_AUDIT_FIELDS}`;

const LIST_GROUPS = gql`query GetGroups($first: Int = 100, $offset: Int = 0, $filter: GroupFilter){
  allGroups(
    filter: $filter,
    first: $first,
    offset: $offset,
    orderBy: [NAME_ASC]) {
    nodes {
      uid
      name
      organizationUid
      userGroupsByGroupUid {
        totalCount
      }
    }
    totalCount
  }
} `;

const LIST_USER_BY_GROUP = gql`query GetUsersByGroup($first: Int = 100, $offset: Int = 0, $groupUid: UUID!){
  allUserGroups(
    first: $first,
    offset: $offset,
    condition: { groupUid: $groupUid }){
    nodes {
      userByUserUid {
        lastName
        firstName
        uid
        createdAt
        classroomUid
        classroomByClassroomUid {
          uid
          name
        }
        userGroupsByUserUid{
          nodes{
            groupByGroupUid{
              uid
              name
            }
          }
        }
      }
    }
    totalCount
  }
} `;

const CREATE_USER_GROUP = gql`mutation CreateUserGroup($groupUid: UUID!, $userUid: UUID!) {
  createUserGroup(input: { userGroup: { groupUid: $groupUid, userUid: $userUid } }) {
    clientMutationId
  }
}
`;

const DELETE_GROUP = gql`mutation DeleteGroup($groupUid: UUID!) {
  deleteGroupByUid(input: { uid: $groupUid }){
    group{
      uid
      name
    }
  }
}
`;

const DELETE_USER_GROUP = gql`mutation DeleteUserGroup($groupUid: UUID!, $userUid: UUID!) {
  deleteUserGroupByUserUidAndGroupUid(input: { groupUid: $groupUid, userUid: $userUid }) {
    clientMutationId
  }
}
`;

const GET_GROUP = gql`query GetGroup($groupUid: UUID!){
  groupByUid(uid: $groupUid){
    name
    uid
  }
} `;

const LIST_USER_UIDS_BY_GROUPS = gql`query GetUserUidsByGroups($groupUids: [UUID!]){
  allUserGroups(filter: { groupUid: { in: $groupUids } }) {
    nodes {
      userUid
    }
  }
} `;

export {
  UPDATE_GROUP,
  CREATE_GROUP,
  LIST_GROUPS,
  LIST_USER_BY_GROUP,
  LIST_USER_UIDS_BY_GROUPS,
  CREATE_USER_GROUP,
  DELETE_GROUP,
  DELETE_USER_GROUP,
  GET_GROUP,
};
